import React from 'react';
import {SidePanelWrapper, Header, CloseButton, Content, Backdrop, Title} from './styles';

class SidePanel extends React.Component {
  render() {
    const {isSidePanelOpen, popSidePanel, title, children, showBackdrop} = this.props;
    return (
      <>
        <Backdrop aria-label="backdrop" showBackdrop={showBackdrop} onClick={popSidePanel} />
        <SidePanelWrapper isOpen={isSidePanelOpen}>
          <Header>
            <Title>{title}</Title>
            <CloseButton aria-label="close" onClick={popSidePanel} />
          </Header>
          <Content>{children}</Content>
        </SidePanelWrapper>
      </>
    );
  }
}

export default SidePanel;
